import jump from 'jump.js';

export const init = () => {
  navHover();
  toggleMobileDropdown();
  toggleMobileNav();
  scrollToLink();
  setHeaderOriginalOffset();
  scrollHeaderNav();
  scrollSecondaryNav();
};

const navHover = () => {
  const navLinks = [...document.querySelectorAll('nav li li a')];

  navLinks.forEach((navLink) => {
    navLink.addEventListener('mouseover', (event) => {
      const topLink = event.target.parentElement.getElementsByTagName('a')[0];
      topLink.classList.add('hover');
    }, false);

    navLink.addEventListener('mouseout', (event) => {
      const topLink = event.target.parentElement.getElementsByTagName('a')[0];
      topLink.classList.remove('hover');
    }, false);
  });
};

const toggleMobileDropdown = () => {
  [...document.querySelectorAll('nav ul ul')].map((subNav) => {
    subNav.parentElement.classList.add('has-children');
    const input = document.createElement('input');
    input.type = 'checkbox';
    input.className = 'toggle-sub-menu';
    subNav.parentElement.insertBefore(input, subNav.parentElement.firstChild);
    return subNav;
  });
};

const toggleMobileNav = () => {
  const navToggle = document.getElementsByClassName('header__navigation__toggle')[0];
  ['touchstart', 'click'].forEach(event => navToggle.addEventListener(event, (e) => {
    e.preventDefault();
    document.body.classList.toggle('mobile-nav-active');
    const accountName = document.getElementsByClassName('account-name');
    if (accountName.length) {
      accountName[0].classList.remove('active');
    }
  }, false));
};

export const scrollHeaderNav = () => {
  if (window.innerWidth < 768) { return; }

  const headerNavigation = document.getElementsByClassName('header__navigation')[0];
  const isScrolling = headerNavigation.classList.contains('header__navigation--scrolling');
  const distance = headerNavigation.getAttribute('data-original-offset') - window.pageYOffset;

  if (distance <= 0 && !isScrolling) {
    headerNavigation.classList.add('header__navigation--scrolling');
  } else if (distance > 0 && isScrolling) {
    headerNavigation.classList.remove('header__navigation--scrolling');
  }
};

export const setHeaderOriginalOffset = () => {
  const header = document.getElementsByTagName('header')[0];
  const headerNavigation = document.getElementsByClassName('header__navigation')[0];
  headerNavigation.classList.remove('header__navigation--scrolling');
  header.style.paddingBottom = headerNavigation.offsetHeight;
  headerNavigation.setAttribute('data-original-offset', headerNavigation.offsetTop);
};

const scrollToLink = () => {
  const scrollToLinks = [...document.querySelectorAll('a[href^="#"]')];

  scrollToLinks.forEach((link) => {
    const id = link.getAttribute('href').split('#').filter(Boolean);
    if (id.length && document.getElementById(id[0])) {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.getElementById(id[0]);
        jump(target);
      }, false);
    }
  });
};

export const scrollSecondaryNav = () => {
  const secondaryNav = document.getElementsByClassName('secondary-navigation')[0];
  if (!secondaryNav) {
    return false;
  }

  const secondaryNavHeight = secondaryNav.offsetHeight;
  if (window.innerHeight < secondaryNavHeight) {
    secondaryNav.classList.remove('secondary-navigation--sticky');
    return false;
  }

  secondaryNav.classList.add('secondary-navigation--sticky');

  return secondaryNav;
};



// WEBPACK FOOTER //
// ./src/assets/js/navigation.js